module.exports = __webpack_public_path__ + "static/WEDDING E&M-204-78300b0d2b57d343e88d7b46f6cf4e7e.jpg";